<h5 mat-dialog-title i18n>Select Print Options</h5>
<div mat-dialog-content>
  <p i18n>Select options for printing.</p>
  <form #printOptionsForm="ngForm" (ngSubmit)="printReport()">
    <div class="form-group">
      <select name="locale" class="form-control select-bidit" [(ngModel)]="locale">
        <option value="en">English</option>
        <option value="es">Español</option>
      </select>
    </div>
    <div>
      <mat-checkbox *ngIf="!isInvoice" id="showSquareFootage" name="showSquareFootage" class="col-form-label" [(ngModel)]="showSquareFootage" i18n>Show Square Footage</mat-checkbox>
    </div>
    <div *ngIf="showLinePricing">
      <mat-checkbox *ngIf="!isInvoice" id="showPricing" name="showPricing" class="col-form-label" [(ngModel)]="showPricing" i18n>Show Item Pricing</mat-checkbox>
    </div>
    <div>
      <mat-checkbox id="showTaxes" name="showTaxes" class="col-form-label" [(ngModel)]="showTaxes" i18n>Show Tax</mat-checkbox>
    </div>
    <div  class="form-group">
      <mat-checkbox *ngIf="!isInvoice" id="hideItemNotes" name="hideItemNotes" class="col-form-label" [(ngModel)]="hideLineItemNotes" i18n>Hide Line Item Notes</mat-checkbox>
    </div>
    <div class="form-group float-right">
      <button type="submit" mat-button class="btn btn-bidit-action mr-1" i18n>Print</button>
      <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
    </div>
    <app-spinner [isRunning]="isRequesting"></app-spinner>
  </form>
</div>
